export enum GdprClauseType {
  GUEST = 'guest',
  NEW_USER = 'new_user',
}

export enum OrganizationLanguage {
  POLISH = 'pl',
  ENGLISH = 'en',
}

export enum GdprLanguage {
  POLISH = 'pl',
  ENGLISH = 'en',
  UKRAINIAN = 'ua',
}

export interface Gdpr {
  createdAt: string;
  gdprClause: string;
  id?: number;
  language: GdprLanguage;
  type: GdprClauseType;
  updatedAt: string;
}

export interface GdprClauseByType {
  [GdprClauseType.GUEST]: Gdpr[];
  [GdprClauseType.NEW_USER]: Gdpr[];
}
